// extracted by css-extract-rspack-plugin
export default {"heading":"heading-1i0snD text-lg","headingSection":"headingSection-KXxVH3 text-sm","supportingItem":"supportingItem-DbjKfn","label":"label-L7fx_m","labelText":"labelText-ZNxXoo"};